/**
 * This is just a utility which helps composing item lists with conditional items
 */
export function createItemList<Item extends object>(
  listIn: Array<Item & { condition?: boolean }> = []
): Item[] {
  return listIn.filter(item => !item.hasOwnProperty('condition') || item.condition)
}
